import { apiSlice } from "./apiSlice";

export const CustomerDashboardSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getDesignKpisByAssets: builder.query({
            query: ({ projectId, assetNames = [] }) => {

                const params = new URLSearchParams();

                if (projectId) {
                    params.set("projectId", projectId);
                }

                assetNames.forEach((name) => {
                    params.append("assetNames", name);
                });

                return {
                    url: `/DesignTracker/kpi/by-asset?${params.toString()}`,
                    method: "GET",
                };
            },
        }),

        getNCRStatusCountByAssets: builder.query({
            query: ({ projectId, assetNames = [] }) => {

                let url = `NCRLog/summary/${projectId}`;

                if (assetNames.length > 0) {
                    const params = new URLSearchParams();

                    assetNames.forEach((name) => {
                        params.append("assetNames", name);
                    });

                    url += `?${params.toString()}`;
                }

                return {
                    url,
                    method: "GET",
                };
            },
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllNCRLog"],
        }),

        getScheduleKpisByAssets: builder.query({
            query: ({ projectId, assetIds = [] }) => {

                let url = `Schedule/${projectId}/schedule-kpis/by-asset`;

                if (assetIds.length > 0) {
                    const params = new URLSearchParams();

                    assetIds.forEach((id) => {
                        params.append("assetid", id);
                    });

                    url += `?${params.toString()}`;
                }

                return {
                    url,
                    method: "GET",
                };
            },
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),

        // Get all comments
        getCustomerDashboardDCommentList: builder.query({
            query: (params) => ({
                url: `CustomerDashboardComment`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllCDComments"],
        }),

        // Create new comment
        createCustomerDashboardComment: builder.mutation({
            query: ({ body }) => ({
                url: `CustomerDashboardComment/addcomments`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["AllCDComments"],
        }),

        // Get all comments
        getProcurementKpi: builder.query({
            query: (params) => ({
                url: `CustomerDashboard/customerdashboard/procurement-kpis`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllCDComments"],
        }),

    }),
});

export const {
    useGetDesignKpisByAssetsQuery,
    useLazyGetDesignKpisByAssetsQuery,
    useGetNCRStatusCountByAssetsQuery,
    useLazyGetNCRStatusCountByAssetsQuery,
    useGetScheduleKpisByAssetsQuery,
    useLazyGetScheduleKpisByAssetsQuery,
    useGetCustomerDashboardDCommentListQuery,
    useCreateCustomerDashboardCommentMutation,
    useLazyGetProcurementKpiQuery
} = CustomerDashboardSlice;